import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AssetDisposal, AssetDisposalCreate, AssetDisposalFilter } from '../data/assetDisposal';

export function createAssetDisposalService(client: AxiosInstance) {
  return createCrudService<AssetDisposal, AssetDisposalCreate, AssetDisposalFilter>(
    client,
    '/asset-management/AssetDisposal',
    'id',
  );
}

export type AssetDisposalService = CrudService<AssetDisposal, AssetDisposalCreate, AssetDisposalFilter>;
